import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { Button, Container, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { root_url } from "../setting";
import JoinerParticipantForm from "./JoinerParticipantForm";
import RunnersParticipantForm from "./RunnersParticipantForm";
class Joiner {
  constructor(
    joinerName,
    cellphone,
    zipcode,
    zipAddress,
    address,
    amount,
    brief
  ) {
    this.joinerName = joinerName;
    this.exponent = null; //대표자
    this.cellphone = cellphone;
    this.zipcode = zipcode;
    this.zipAddress = zipAddress;
    this.address = address;
    this.paymentType = "BANK";
    this.paymentStatus = "RSVT"; //RSVD => RSVT
    this.brief = brief;
    this.amount = amount;
  }
}
const GroupParticipantForm = ({ setNowProcess, setRes, ticketInfo }) => {
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useForm();
  const [ticketArray, setTicketArray] = useState([]);
  const [popupShow, setPopupShow] = useState(false);
  const [runnerList, setRunnerList] = useState([]);
  const [isUnique, setIsUnique] = useState(false);
  const onCompletePostCode = ({ zonecode, roadAddress, buildingName }) => {
    setPopupShow(false);
    setAddress({
      zonecode,
      roadAddress,
      buildingName,
    });
  };

  const [address, setAddress] = useState({
    zonecode: "",
    roadAddress: "",
    buildingName: "",
  });
  const [today, setToday] = useState(new Date());
  const [firstDisabled, setFirstDisabled] = useState(false);
  const [flag, setFlag] = useState(false);
  const [modal, setModal] = useState(false);
  const submitButton = useRef();
  const onSubmit = (data) => {
    if (!isUnique) {
      alert("단체명 중복 확인을 해주세요!");
      return;
    } else if (!flag) {
      setModal(true);
      // setFlag(true);
      return;
    } else {
      const {
        name,
        groupName,
        cellphone,
        detailAddress,
        participantName,
        birthday,
        participantCellphone,
      } = data;
      //접수자 정보 초기화
      let brief;
      //total amount
      // let amount = ticketInfo[participantCourse].ticketPrice;
      let amount = 0;
      console.log(runnerList);
      console.log(ticketInfo);
      for (let runner in runnerList) {
        //   console.log(runner);
        amount += ticketInfo[runnerList[runner].ticketSeq - 1].ticketPrice;
      }
      if (amount > 0) {
        //전화번호 네자리로 brief 설정
        brief = `${name}${cellphone.slice(
          cellphone.length - 4,
          cellphone.length
        )}`;
      } else {
        brief = "무료";
      }
      let addressInBuilding = address.roadAddress; //건물명 있을때는 추가해주기
      if (address.buildingName) {
        addressInBuilding += `(${address.buildingName})`;
      }
      const joiner = new Joiner(
        name,
        cellphone,
        address.zonecode,
        addressInBuilding,
        detailAddress,
        amount,
        brief
      );
      if (amount === 0) {
        joiner.paymentStatus = "CMPL"; //무료인 경우, 신청과 동시에 결제완료 처리가 되야한다.
      }
      joiner.exponent = groupName;
      //runners
      let runners = runnerList;
      console.log(joiner, runners);
      console.log("url" + `${root_url}/api/applicant/applyFor`);

      axios({
        method: "post",
        url: `${root_url}/api/applicant/applyFor`,
        // data: { joiner, runner: runnerInfo, runners: runners },
        data: { joiner, runners },
        headers: { "Content-Type": "application/json" },
      })
        .then((res) => {
          console.log(res);
          const { data } = res;
          if (res.status === 200) {
            setRes(data);
            setNowProcess(3);
            // history.push({
            //   pathname: '/apply/payment',
            //   state: { data: data, ticketInfo: ticketInfo }, //만약 apply/payment에 url로 접속한다면 이를 막도록 해야함
            // });
          }
        })
        .catch((e) => {
          if (e?.response === undefined) {
            alert(
              "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
            );
          } else {
            alert(e?.response.data?.errorMessage);
          }
          console.log(e?.response);

          //error message 보여줘야함!!!!
          if (
            typeof e?.response?.data !== undefined ||
            e?.response?.data?.errorMessage !== undefined
          ) {
            alert(e.response.data.errorMessage);
          } else {
            alert(
              "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
            );
          }
          setNowProcess(2);
          //중복등으로 에러가 난 경우에는 status에 따라 적당히 유도를 해줘야한다.
        });
    }
  };
  useEffect(() => {
    console.log("-------- 이 수술은 내가 집도 한다 --------");
    console.log(runnerList);
  }, [runnerList]);

  const getModalContents = (runnerList) => {
    let contents = "단체\n";
    let ticketCntArray = new Array(ticketArray.length).fill(0);
    runnerList.map((runner, idx) => {
      console.log(runner);
      console.log(ticketArray[runner.ticketSeq - 1].ticketName);
      ticketCntArray[runner.ticketSeq - 1] += 1;
    });
    for (let i = 0; i < ticketCntArray.length; i++) {
      if (ticketCntArray[i] > 0) {
        contents = `${contents}${ticketArray[i].ticketName} ${ticketCntArray[i]}명\n`;
      }
    }
    contents = contents.replace(/(?:\r\n|\r|\n)/g, "<br />");

    return contents;
  };

  useEffect(() => {
    //처음에 ticketInfo를 display_order순으로 맞춰줘야함
    ticketInfo.sort((a, b) => {
      return a.displayOrder - b.displayOrder;
    });
    console.log(ticketInfo);
    // console.log(new_array);
    setTicketArray(ticketInfo);
  }, [ticketInfo]);
  return (
    <div>
      <Modal show={modal} onHide={() => setModal(false)} size="lg" centered>
        <Modal.Header
          closeButton
          onClick={() => {
            setFlag(false);
          }}
        ></Modal.Header>
        <Modal.Body
          dangerouslySetInnerHTML={{ __html: getModalContents(runnerList) }}
        ></Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setModal(false);
              setFlag(true);
              submitButton.current.click();
            }}
          >
            확인했습니다
          </Button>
        </Modal.Footer>
      </Modal>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Container className="row m-0">
          <JoinerParticipantForm
            formCheck={{ register, errors, getValues }}
            popupInfo={{ popupShow, setPopupShow, address, onCompletePostCode }}
            setIsUnique={setIsUnique}
          />
          <RunnersParticipantForm
            formCheck={{ register, errors }}
            info={{ ticketArray, ticketInfo }}
            setRunnerList={setRunnerList}
            runnerList={runnerList}
            setFlag={setFlag}
          />
        </Container>
        <input
          ref={submitButton}
          type="submit"
          className="bg-custom-color p-2 ps-3 pe-3 rounded text-white m-5"
          style={{ border: "none" }}
          value="접수하기"
        />
      </form>
    </div>
  );
};

export default GroupParticipantForm;
